import React, { useEffect, useState, useRef } from "react";
import { Form, Col, Row } from "react-bootstrap";
import axios from "axios";
import Button from "../../../components/Button";
import LoadingContent from "../../../components/LoadingContent";
import { ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";

interface TeamChampionship {
  name: string;
  championship_id: number;
  team_championship_id: number;
}

const DeleteTeamChampionship = () => {
  const { access } = useIsAdmin();
  document.title = "LVF1 - Delete Team Championship";
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const [dataForm, setDataForm] = useState({
    championship: "",
    team: "",
  });
  const [validated, setValidated] = useState(false);
  const [update, setUpdate] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [teams, setTeams] = useState<TeamChampionship[]>([]);
  const [data, setData] = useState<{
    champs: { name: string; id: number }[];
    assignments: TeamChampionship[];
    users: User[];
  }>();

  const setTeamsFromChampionship = (value: string) => {
    const teams_filtered = data?.assignments.filter(
      (assignment) => parseInt(value) === assignment.championship_id,
    );
    if (teams_filtered != null) setTeams(teams_filtered);
  };

  const inputChange = ({ target }: { target: any }) => {
    const { name, value } = target;
    setDataForm({
      ...dataForm,
      [name]: value,
    });
  };

  const submitForm = (event: any) => {
    if (token == null) return;
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const formDataFiles = new FormData();
    formDataFiles.append("user", user);
    formDataFiles.append("token", JSON.parse(token).token);
    formDataFiles.append("championship", dataForm.championship);
    formDataFiles.append("team", dataForm.team);

    if (!(form !== null && form.checkValidity() === false)) {
      setUploading(true);
      axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/admin/deleteTeamChampionship`,
          formDataFiles,
        )
        .then(() => {
          toast.success("Team Championship Deleted correctly");
          setUploading(false);
          setValidated(false);
          setDataForm({ ...dataForm, team: "" });
          setUpdate(!update);
        })
        .catch(({ response }) => {
          toast.error(response.data.message);
          setUploading(false);
          throw new Error(response);
        });
    }
    setValidated(true);
  };

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/team/teamLogo`,
      )
      .then(({ data }) => {
        setData(data);
        setTeams(
          data?.assignments.filter(
            (assignment: { championship_id: number }) =>
              parseInt(data.champs[0].id) === assignment.championship_id,
          ),
        );
        setDataForm({
          ...dataForm,
          championship: data.champs[0].id,
        });
      })
      .catch(({ response }) => {
        console.log(response);
        throw new Error(response);
      });
  }, [update]);

  if (!access) return <ErrorPage />;
  if (data == null) return <LoadingContent />;
  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container">
        <Title text="Delete Team Championship" />
        <small className="mandatory-fields">(*) Required fields</small>
        <Form noValidate validated={validated} onSubmit={submitForm}>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="6">
              <Form.Label>Championship (*)</Form.Label>
              <Form.Select
                name="championship"
                required
                value={dataForm.championship}
                onChange={(e: any) => {
                  inputChange(e);
                  setTeamsFromChampionship(e.target.value);
                }}
              >
                {data?.champs.map((champ) => {
                  return (
                    <option value={champ.id} key={champ.id}>
                      {champ.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="6">
              <Form.Label>Team (*)</Form.Label>
              <Form.Select
                name="team"
                required
                value={dataForm.team}
                onChange={(e) => {
                  inputChange(e);
                }}
              >
                <option value="" disabled>
                  None
                </option>
                {teams.map((team) => {
                  return (
                    <option
                      value={team.team_championship_id}
                      key={team.team_championship_id}
                    >
                      {team.name}
                    </option>
                  );
                })}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-center">
            <small className="mandatory-fields red">
              You will remove the driver assignments of the team selected!
            </small>
            {uploading ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
            ) : (
              <Button text={"Delete Team Championship"} type="submit" />
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default DeleteTeamChampionship;
